module.exports = __webpack_public_path__ + "img/undraw_apps_m7mh.9f6e4e67.svg";